/**
 * Rotas disponíveis na aplicação.
 */
export enum TypesRoutes {
  COVERAGE_AVAILABLE = '/',
}
